module.exports = __webpack_public_path__ + "img/type5.d5cd8c3e.png";